import { render, staticRenderFns } from "./LpuPhone.vue?vue&type=template&id=7e6b9a3a&"
import script from "./LpuPhone.vue?vue&type=script&lang=ts&setup=true&"
export * from "./LpuPhone.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e6b9a3a')) {
      api.createRecord('7e6b9a3a', component.options)
    } else {
      api.reload('7e6b9a3a', component.options)
    }
    module.hot.accept("./LpuPhone.vue?vue&type=template&id=7e6b9a3a&", function () {
      api.rerender('7e6b9a3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/LpuPhone.vue"
export default component.exports